import { useEffect, useRef } from "react";
import { keys } from "../../../../../../common/util/Object/keys";
import { OriginKey, Post, PostComment } from "../types";

function getPostKey(postedUserId: number, postNo: number) {
    return `${postedUserId}-${postNo}`;
}

const functionsToUpdateBackgroundComments: {
    [key in OriginKey]: {
        [postKey in string]?: (newComments: PostComment[]) => void;
    };
} = { TopPage: {}, SocialPanel: {}, OtherUserPanel: {} };

export function useSyncCommentsStateWithBackgroundPanel(
    post: Post,
    originKey: OriginKey,
    setComments: (comments: PostComment[]) => void,
    comments: PostComment[]
) {
    useEffect(() => {
        // set functionsToUpdateBackgroundComments
        const postKey = getPostKey(post.userId, post.postNo);
        functionsToUpdateBackgroundComments[originKey][postKey] =
            newComments => {
                if (newComments.length > 0) {
                    setComments(newComments);
                }
            };
        return () => {
            delete functionsToUpdateBackgroundComments[originKey][postKey];
        };
    }, [originKey, post]);

    const currentDataContainer = useRef<{
        comments: PostComment[];
        originKey: OriginKey;
        post: Post;
    } | null>(null);
    currentDataContainer.current = { comments, originKey, post };
    useEffect(() => {
        return () => {
            // Sync data on unmount
            if (!currentDataContainer.current) {
                return;
            }
            const { comments, originKey, post } = currentDataContainer.current;
            keys(functionsToUpdateBackgroundComments).forEach(key => {
                if (key === originKey) {
                    return;
                }
                functionsToUpdateBackgroundComments[key][
                    getPostKey(post.userId, post.postNo)
                ]?.(comments);
            });
        };
    }, [currentDataContainer]);
}
